/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MarketingTemplateGetRequest } from '../models/marketing-template-get-request';
import { MarketingTemplateGetResponse } from '../models/marketing-template-get-response';
import { MarketingTemplateListGetRequest } from '../models/marketing-template-list-get-request';
import { MarketingTemplateListGetResponse } from '../models/marketing-template-list-get-response';
import { MarketingTemplateScopeListGetRequest } from '../models/marketing-template-scope-list-get-request';
import { MarketingTemplateScopeListGetResponse } from '../models/marketing-template-scope-list-get-response';
import { MarketingTemplateUpdateRequest } from '../models/marketing-template-update-request';
import { MarketingTemplateUpdateResponse } from '../models/marketing-template-update-response';
import { ProductMarketingTemplateGetRequest } from '../models/product-marketing-template-get-request';
import { ProductMarketingTemplateGetResponse } from '../models/product-marketing-template-get-response';
import { ProductMarketingTemplateListGetRequest } from '../models/product-marketing-template-list-get-request';
import { ProductMarketingTemplateListGetResponse } from '../models/product-marketing-template-list-get-response';
import { ProductMarketingTemplateUpdateRequest } from '../models/product-marketing-template-update-request';
import { ProductMarketingTemplateUpdateResponse } from '../models/product-marketing-template-update-response';

@Injectable({
  providedIn: 'root',
})
export class MarketingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1MarketingListPost
   */
  static readonly V1MarketingListPostPath = '/v1/marketing/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingListPost$Plain$Response(params?: {
    body?: MarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingListPost$Plain(params?: {
    body?: MarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateListGetResponse> {

    return this.v1MarketingListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateListGetResponse>) => r.body as MarketingTemplateListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingListPost$Json$Response(params?: {
    body?: MarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingListPost$Json(params?: {
    body?: MarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateListGetResponse> {

    return this.v1MarketingListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateListGetResponse>) => r.body as MarketingTemplateListGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingGetPost
   */
  static readonly V1MarketingGetPostPath = '/v1/marketing/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingGetPost$Plain$Response(params?: {
    body?: MarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingGetPost$Plain(params?: {
    body?: MarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateGetResponse> {

    return this.v1MarketingGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateGetResponse>) => r.body as MarketingTemplateGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingGetPost$Json$Response(params?: {
    body?: MarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingGetPost$Json(params?: {
    body?: MarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateGetResponse> {

    return this.v1MarketingGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateGetResponse>) => r.body as MarketingTemplateGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingUpdatePost
   */
  static readonly V1MarketingUpdatePostPath = '/v1/marketing/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingUpdatePost$Plain$Response(params?: {
    body?: MarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingUpdatePost$Plain(params?: {
    body?: MarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateUpdateResponse> {

    return this.v1MarketingUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateUpdateResponse>) => r.body as MarketingTemplateUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingUpdatePost$Json$Response(params?: {
    body?: MarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingUpdatePost$Json(params?: {
    body?: MarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateUpdateResponse> {

    return this.v1MarketingUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateUpdateResponse>) => r.body as MarketingTemplateUpdateResponse)
    );
  }

  /**
   * Path part for operation v1MarketingScopeListPost
   */
  static readonly V1MarketingScopeListPostPath = '/v1/marketing/scope/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingScopeListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingScopeListPost$Plain$Response(params?: {
    body?: MarketingTemplateScopeListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateScopeListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingScopeListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateScopeListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingScopeListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingScopeListPost$Plain(params?: {
    body?: MarketingTemplateScopeListGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateScopeListGetResponse> {

    return this.v1MarketingScopeListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateScopeListGetResponse>) => r.body as MarketingTemplateScopeListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingScopeListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingScopeListPost$Json$Response(params?: {
    body?: MarketingTemplateScopeListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MarketingTemplateScopeListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingScopeListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarketingTemplateScopeListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingScopeListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingScopeListPost$Json(params?: {
    body?: MarketingTemplateScopeListGetRequest
  },
  context?: HttpContext

): Observable<MarketingTemplateScopeListGetResponse> {

    return this.v1MarketingScopeListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<MarketingTemplateScopeListGetResponse>) => r.body as MarketingTemplateScopeListGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingProductTemplateGetPost
   */
  static readonly V1MarketingProductTemplateGetPostPath = '/v1/marketing/product/template/get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateGetPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateGetPost$Plain$Response(params?: {
    body?: ProductMarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateGetPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateGetPost$Plain(params?: {
    body?: ProductMarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateGetResponse> {

    return this.v1MarketingProductTemplateGetPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateGetResponse>) => r.body as ProductMarketingTemplateGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateGetPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateGetPost$Json$Response(params?: {
    body?: ProductMarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateGetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateGetPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateGetPost$Json(params?: {
    body?: ProductMarketingTemplateGetRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateGetResponse> {

    return this.v1MarketingProductTemplateGetPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateGetResponse>) => r.body as ProductMarketingTemplateGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingProductTemplateListPost
   */
  static readonly V1MarketingProductTemplateListPostPath = '/v1/marketing/product/template/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateListPost$Plain$Response(params?: {
    body?: ProductMarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateListPost$Plain(params?: {
    body?: ProductMarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateListGetResponse> {

    return this.v1MarketingProductTemplateListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateListGetResponse>) => r.body as ProductMarketingTemplateListGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateListPost$Json$Response(params?: {
    body?: ProductMarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateListGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateListGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateListPost$Json(params?: {
    body?: ProductMarketingTemplateListGetRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateListGetResponse> {

    return this.v1MarketingProductTemplateListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateListGetResponse>) => r.body as ProductMarketingTemplateListGetResponse)
    );
  }

  /**
   * Path part for operation v1MarketingProductTemplateUpdatePost
   */
  static readonly V1MarketingProductTemplateUpdatePostPath = '/v1/marketing/product/template/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateUpdatePost$Plain$Response(params?: {
    body?: ProductMarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateUpdatePost$Plain(params?: {
    body?: ProductMarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateUpdateResponse> {

    return this.v1MarketingProductTemplateUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateUpdateResponse>) => r.body as ProductMarketingTemplateUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1MarketingProductTemplateUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateUpdatePost$Json$Response(params?: {
    body?: ProductMarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductMarketingTemplateUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MarketingService.V1MarketingProductTemplateUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarketingTemplateUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1MarketingProductTemplateUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1MarketingProductTemplateUpdatePost$Json(params?: {
    body?: ProductMarketingTemplateUpdateRequest
  },
  context?: HttpContext

): Observable<ProductMarketingTemplateUpdateResponse> {

    return this.v1MarketingProductTemplateUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductMarketingTemplateUpdateResponse>) => r.body as ProductMarketingTemplateUpdateResponse)
    );
  }

}
